export enum DeviceToggleBtnValues {
    Number = 'number',
    Percent = 'percent',
}

export type LegendDataType = {
    name: string;
    icon?: JSX.Element;
}[];

export type PieChartData = {
    name: string;
    value: number;
    percent?: number;
    color?: string;
    label: string;
};

export type PieChartsDataType = {
    pieChartDataOpened: PieChartData[];
    pieChartDataClicked: PieChartData[];
    pieChartDataUnsubscribed: PieChartData[];
};

export interface DeviceDetailsToggleBtnOptInterface {
    label: string;
    value: DeviceToggleBtnValues;
}

export interface DetailedRow {
    name?: string;
    opens?: number | string;
    rate?: string;
    opened?: number | string;
    clicked?: number | string;
    unsubscribed?: number | string;
}

export enum RadioValues {
    Opened = 'opened',
    Clicked = 'clicked',
    Unsubscribed = 'unsubscribed',
}

export interface FiltersInterface {
    from: string;
    to: string;
    setFrom: (from) => void;
    setTo: (to) => void;
    queryCampaignName?: string;
    setQueryCampaignName?: (queryCampaignName) => void;
    selectedCampaignName: string;
    setSelectedCampaignName: (selectedCampaignName) => void;
    selectedChannelName?: string;
    setSelectedChannelName?: (selectedChannelName) => void;
    queryChannelName?: string;
    setQueryChannelName?: (queryChannelName) => void;
}
